import styled from 'styled-components';

const AboutUsHeader = styled.h1`
  font-family: "Avenir Black", "Arial Black", sans-serif;
  font-size: 30px;
  letter-spacing: 1px;
  text-align: center;
  line-height: 41px;
  text-transform: initial;
  margin: 0;
`;

export default AboutUsHeader;
